<template>
<loading :show="show" :label="label" :overlay="overlay"></loading>
    <form class="form-horizontal">
        <div class="form-body">
            <div class="form-group">

                <div class="col-md-3 new-padding-inputs input-cpfcnpj">
                    <label class="control-label">CPF/CNPJ</label>
                    <input type="text" class="form-control" placeholder="CPF">
                </div>

                <div class="col-md-3 new-padding-inputs input-fornecedor">
                    <label class="control-label">Nome do Fornecedor</label>
                    <input type="text" class="form-control" placeholder="Nome do Fornecedor">
                </div>

                <div class="col-md-4 new-padding-inputs input-objeto">
                    <label class="control-label">Objeto</label>
                    <input type="text" class="form-control" placeholder="Objeto">
                </div>

                <div class="col-md-2 botao-pesquisar">
                    <label class="control-label"></label>
                    <button class="form-control btn green" style="margin-top: 8px;" v-on:click="pesquisar">Pesquisar</button>
                </div>
            </div>
        </div>
    </form>    
    <hr >
    <div>
        <div class="portlet-body">
            <cp-table-sete :dadosconteudo="dadosconteudo"></cp-table-sete>
        </div>
    </div>
</template>
<script>
    import CpTableSete from '../../tables/table-t7/table.vue'
    import loading from 'vue-full-loading'

            export default{
                data() {
                    return{
                        dadosconteudo: {},
                        show: false,
                        label: 'Carregando...',
                        overlay: true
                    }
                },
                components: {
                    CpTableSete, loading
                },
                props: {
                    line: {}
                },
                watch: {
                    $route () {
                        this.pesquisar();
                    }
                },                
                methods: {
                    pesquisar(ev) {

                        /* dados conteudo 
                        dadosconteudo: {
                            current_page: '1',
                            last_page: 1,
                            per_Page: 20,
                            total: '20',
                            tr: [
                                {
                                    processo: '007355/2015',
                                    infomodal: '473',
                                    numerolicitacao: '0042016',
                                    cpfcnpj: '32.176.749/0001-80',
                                    nomefornecedor: 'Fornecedor Nome Completo',
                                    dataassinatura: '10/04/2018',
                                    datavalidade: '10/04/2018',
                                    objeto: 'CONTRATAÇÃO DE EMPRESA ESPECIALIZADA PARA EXECUÇÃO DE OBRA DE DE ENGENHARIA, CONSTRUÇÃO DA PRAÇA SÃO PEDRO, NA RUA ISAIAS DÓCIO, NESTA CIDADE DE IGRAPIÚNA-BAHIA.',
                                    valorcontrato: 'R$ 10.000,00'
                                }
                            ]
                        }
                        */
                        $.ajaxSetup({
                            async: false
                        });

                        this.show = true;
                        var self = this;
                        //json com os dados do menu
                        setTimeout(function(){
                            MPL.loadDadosContratos(1, function (links)
                            {
                                self.dadosconteudo = links[0];
                                self.show = false;
                                $('.table-responsive').fadeIn('fast');
                                //console.log(self.dadosconteudo)
                            });
                        }, 200);
                        //self.show = false;
                        //$('.table-responsive').fadeIn('fast');
                        $.ajaxSetup({
                            async: true
                        });
                        
                        // $('.table-responsive').fadeIn('fast');                        
                    }
                },
                ready() {

                    $('form').bind('submit',function(e){e.preventDefault();});

                    this.pesquisar();
                }
            }
</script>
<style scoped>
    @media (min-width: 992px){
        .input-fase{
            width: 13%;
            padding-left: 15px;
        }

        .input-entidade{
            width: 64.5%;
            padding-right: 5px;
        }

        .input-credor{
            width: 48.6%;
        }

        .input-cpfcnpj{
            padding-left: 15px;
        }

        .botao-pesquisar{
            float:right;
            padding-right: 15px; 
        }

        .input-cpfcnpj{
            width: 16%;
        }

        .input-objeto{
            width: 35.5%;
        }

        .input-fornecedor{
           width: 34%;
        }


    }
</style>


// WEBPACK FOOTER //
// filtro6.vue?bc9d820a